<template>
  <div id="29_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{ errorMessage
      }}
        )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-radio-group v-model="otrimPriznach" column @change="getMainTableData()">
          <v-radio label="Призначена" value="1"></v-radio>
          <v-radio label="Отримана" value="2"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-menu v-model="PMenuPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
          offset-y min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="PDate" label="Починаючи з:" prepend-icon="event" readonly v-bind="attrs" v-on="on">
            </v-text-field>
          </template>
          <v-date-picker v-model="PDate" locale="uk" :first-day-of-week="1" @input="chPDate()"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-menu v-model="KMenuPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
          offset-y min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="KDate" label="Закінчуючі:" prepend-icon="event" readonly v-bind="attrs" v-on="on">
            </v-text-field>
          </template>
          <v-date-picker v-model="KDate" locale="uk" :first-day-of-week="1" @input="chKDate()"></v-date-picker>
        </v-menu>
      </v-col>

    </v-row>

    <v-card>
      <v-card-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="getMainTableData()">mdi-update</v-icon>
          </template>
          <span>Поновити таблицю</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" :color="filterUse" v-on="on" @click="dialogFilterShow = true">mdi-filter</v-icon>
          </template>
          <span>Фільтри</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        Заявки.
        <v-spacer></v-spacer>

        <v-text-field v-model="mainTableSearch" append-icon="mdi-magnify" label="Search" single-line hide-details>
        </v-text-field>
      </v-card-title>
      <v-data-table :headers="mainTableHeaders" :items="mainTableItems" :search="mainTableSearch" :items-per-page="10"
        dense multi-sort>
        <template v-slot:item.status="{ item }">
          <v-chip :color="item.color" small outlined>
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click.stop="dialogKlientOpen(item.idklient)">mdi-account-edit</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- in Filter  -->
    <v-dialog v-model="dialogFilterShow" scrollable max-width="1200" @click:outside="dialogFilterClose()">
      <v-card>
        <v-toolbar dense flat dark>
          <v-btn icon dark @click="dialogFilterShow = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Фільтри</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialogFilterClose()">Закрити</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="min-height: 600px;">

          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-select v-model="filterRezonListSelected" :items="filterRezonList" item-text="name" item-value="id"
                    label="Причина" multiple chips></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select v-model="filterStatusListSelected" :items="filterStatusList" item-text="name"
                    item-value="id" label="Стан" multiple chips></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select v-model="filterNaspListSelected" :items="filterNaspList" item-text="name" item-value="id"
                    label="Нас.п." multiple chips></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select v-model="filterStreetListSelected" :items="filterStreetList" item-text="name"
                    item-value="id" label="Вулиця" multiple chips></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>

        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- out Filter  -->

    <ClientDetailsModal isOpen="dialogKlientShow" />
  </div>
</template>


<script>
import ClientDetailsModal from './29_client_details_modal.vue'

export default {
  components: {
    ClientDetailsModal
  },
  data: function () {
    return {
      currentClientId: undefined,
      errorMessage: '',
      errorAlertShow: false,
      progresLineShow: false,
      otrimPriznach: "1",
      PDate: '',
      PMenuPicker: false,
      KDate: '',
      KMenuPicker: false,
      Datp: '',
      DatpPicker: false,
      ttteee: '',
      mainTableSearch: '',
      mainTableHeaders: [
        { text: 'Клієнт', value: 'klient', align: 'start' },
        { text: 'Нас.П.', value: 'nasp' },
        { text: 'Вулиця', value: 'street' },
        { text: 'Буд', value: 'building' },
        { text: 'кв', value: 'kv' },
        { text: 'Отримана', value: 'otrim' },
        { text: 'Призначена', value: 'priznach' },
        { text: 'Причина', value: 'rezon' },
        { text: 'Стан', value: 'status' },
        { text: 'Коментар', value: 'notes' },
        { text: '', value: 'actions', sortable: false },
      ],
      mainTableItems: [],
      detailKlientPib: '',
      detailKlientNasp: '',
      detailKlientStreet: '',
      detailKlientBuilding: '',
      detailKlientKv: '',
      detailKlientTel: '',
      detailKlientModel: '',
      detailKlientDatp: '',
      detailKlientComent: '',
      dialogKlientShow: false,
      detailKlientChe: false,
      detailClientFormControl: {
        pib: "",
        nasp: "",
        street: "",
        building: "",
        kv: "",
        tel: "",
        model: "",
        datp: "",
        coment: ""
      },
      detailClientFormFetch: {
        pib: "",
        nasp: "",
        street: "",
        building: "",
        kv: "",
        tel: "",
        model: "",
        datp: "",
        coment: ""
      },
      detailKlientTableHeaders: [
        { text: 'Отримана', value: 'otrim' },
        { text: 'Призначена', value: 'priznach' },
        { text: 'Причина', value: 'rezon' },
        { text: 'Стан', value: 'status' },
        { text: 'Коментар', value: 'notes', sortable: false },
      ],
      detailKlientTableItems: [],
      dialogFilterShow: false,
      filterRezonList: [],
      filterRezonListSelected: [],
      filterStatusList: [],
      filterStatusListSelected: [],
      filterNaspList: [],
      filterNaspListSelected: [],
      filterStreetList: [],
      filterStreetListSelected: [],

    }
  },
  watch: {
  },
  methods: {
    getMainTableData() {
      this.progresLineShow = true
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          act: '29',
          ww: '1',
          pp: localStorage.pp,
          pn: localStorage.pn,
          otrimPriznach: this.otrimPriznach,
          PDate: this.PDate,
          KDate: this.KDate,
          filterRezon: this.filterRezonListSelected,
          filterStatus: this.filterStatusListSelected,
          filterNasp: this.filterNaspListSelected,
          filterStreet: this.filterStreetListSelected,
        })
      };
      fetch(this.$store.getters.apiUrl, requestOptions)
        .then((data) => {
          if (!data.ok) {
            const error = (data && data.message) || data.status
            return Promise.reject(error)
          }
          return data
        })
        .then((data) => data.json())
        .then((data) => {
          if (data.isauth == true) {
            // -----------------------------------------------
            const arr = data.streetslist.map((el) => el.id)

            // -----------------------------------------------
            this.mainTableItems = data.tablelist
            this.filterRezonList = data.rezonlist
            this.filterStatusList = data.statuslist
            this.filterNaspList = data.nasplist
            this.filterStreetList = arr
            this.PDate = data.PDate
            this.KDate = data.KDate
            this.progresLineShow = false
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(() => { })
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
    },
    chPDate() {
      this.PMenuPicker = false
      this.getMainTableData()
    },
    chKDate() {
      this.KMenuPicker = false
      this.getMainTableData()
    },
    chDatp() {
      this.DatpPicker = false
    },

    //-------------------------------------dialog Client ---------------------------------

    handleSelectNasp(event) {
      this.detailClientFormControl.nasp = event
    },
    handleSelectStreet(event) {
      this.detailClientFormControl.street = event
    },

    async dialogKlientOpen(item) {
      this.currentClientId = item
      this.dialogKlientShow = true
      this.progresLineShow = true
      const fetchResult = await fetch(this.$store.getters.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          act: '29',
          ww: '2',
          pp: localStorage.pp,
          pn: localStorage.pn,
          idklient: item,

        })
      })
      const jsonData = await fetchResult.json()
      if (jsonData.isauth == true) {
        this.detailClientFormFetch.pib = jsonData.detailKlientPib
        this.detailClientFormFetch.nasp = jsonData.detailKlientNasp.id
        this.detailClientFormFetch.street = jsonData.detailKlientStreet.id
        this.detailClientFormFetch.building = jsonData.detailKlientBuilding
        this.detailClientFormFetch.kv = jsonData.detailKlientKv
        this.detailClientFormFetch.tel = jsonData.detailKlientTel
        this.detailClientFormFetch.model = jsonData.detailKlientModel
        this.detailClientFormFetch.datp = jsonData.detailKlientDatp
        this.detailClientFormFetch.coment = jsonData.detailKlientComent
        this.detailClientFormControl = Object.assign({}, this.detailClientFormFetch)
        this.detailKlientTableItems = jsonData.detailKlientTableItems
        this.progresLineShow = false
        console.log(this.detailClientFormFetch, 'this.detailClientFormFetch')
        console.log(this.detailClientFormControl, 'this.detailClientFormControl')
        console.log(this.filterStreetList, 'this.filterStreetList')
      }
      if (jsonData.isauth == false) {
        this.$router.push('/login').catch(() => { })
      }
    },

    async dialogClientSaveAndClose() {
      const payload = {}
      Object.keys(this.detailClientFormControl).forEach(el => {
        if (typeof this.detailClientFormControl[el] === "string" && this.detailClientFormControl[el] !== this.detailClientFormFetch[el]) {
          payload[el] = this.detailClientFormControl[el]
        }
        if (typeof this.detailClientFormControl[el] === "object" && el === 'nasp' && this.detailClientFormControl[el].id !== this.detailClientFormFetch[el].id) {
          payload[el] = this.detailClientFormControl[el].id
        }
      })
      const result = await fetch(this.$store.getters.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          act: '29',
          ww: '3',
          pp: localStorage.pp,
          pn: localStorage.pn,
          idklient: this.currentClientId,
          payload: payload
        })
      })
      const json = await result.json()
      console.log(json)

      this.dialogKlientShow = false
      this.detailKlientPib = ''
      this.detailKlientChe = false
      this.currentClientId = undefined
    },

    dialogClientClose() {
      this.dialogKlientShow = false
      this.detailKlientPib = ''
      this.detailKlientChe = false
      this.currentClientId = undefined
    },
    //--------------------------------- END dialog client --------------------------------- 
    dialogFilterClose() {
      this.dialogFilterShow = false
      this.getMainTableData()
    },


  },
  computed: {
    filterUse: function () {
      if (this.filterRezonListSelected.length > 0
        || this.filterStatusListSelected.length > 0
        || this.filterNaspListSelected.length > 0
        || this.filterStreetListSelected.length) {
        return 'red'
      }
      return ' '
    },

  },
  created: function () {
    this.getMainTableData()
  },
}
</script>